import sortBy from "lodash/sortBy";

export function sortProductGroups<Group extends { fullPathName: string }>(groups: Group[]): Group[] {
  return sortBy(
    groups,
    g => g.fullPathName.toLowerCase(),
  );
}

type IsGroupAnAncestorGroup =
  { id: string; parentGroup: { id: string } | null } |
  { id: string; parentGroupId: string | null };

export function isGroupAnAncestor(
  groupId: string,
  targetGroupId: string, groups: Map<string, IsGroupAnAncestorGroup>,
): boolean {
  if (groupId === targetGroupId) {
    return true;
  }

  const targetGroup = groups.get(targetGroupId)!;
  const parentGroupId = 'parentGroupId' in targetGroup ? targetGroup.parentGroupId : targetGroup.parentGroup?.id;

  if (!parentGroupId) return false;
  return isGroupAnAncestor(groupId, parentGroupId, groups);
}
